// removed by extract-text-webpack-plugin
module.exports = {"sweet-alert":"_1pWO7DepYVZ6SOaUd0Rw1L","btn":"t1LEuKH1wVLPhwaYxgqGC","btnAccept":"_2ftzkDvN4yc-Skyiec7W9q","btnNoAccept":"_2-VbUCiCxprRQFjb4i7muQ","modal_container":"_1wIu0J5JDRnuBpaXOEZaku"};


//////////////////
// WEBPACK FOOTER
// ./src/common/global/modal/component/Modal.css
// module id = 315
// module chunks = 0 1 2